import type { ClassValue } from 'clsx'

import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/*
 * tailwind-merge only knows Tailwind's default scale. Without these, a custom
 * size such as `text-label` is mistaken for a text color and silently dropped
 * when it meets `text-muted-foreground` in the same cn() call.
 * Keep this list in sync with the @theme tokens in src/styles/globals.css.
 */
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: ['display', 'headline', 'title', 'heading', 'subheading', 'lede', 'body', 'caption', 'label'],
            leading: ['body', 'display'],
            tracking: ['label', 'heading'],
            container: ['site', 'reading'],
            ease: ['editorial']
        }
    }
})

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}
